import React from 'react';
const items = [{
  emoji: '📚',
  text: '5 professionele e-books (PDF)'
}, {
  emoji: '⚡',
  text: 'Direct te downloaden na betaling'
}, {
  emoji: '📱',
  text: 'Op elk apparaat te lezen'
}, {
  emoji: '∞',
  text: 'Levenslange updates'
}];
export function InstantAccessSection() {
  return <section className="bg-[#F1ECE3] px-4 py-20 sm:px-6 md:py-28" data-id="element-89" data-mp="1hnkc8q2ak49r">
      <div className="mx-auto max-w-4xl text-center" data-id="element-90" data-mp="1hm98gq8uiwin">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-brand-terracotta" data-id="element-91" data-mp="1wbxcw0cbqbal">Vandaag in je inbox</p>
        <h2 className="mb-12 text-3xl font-semibold tracking-[-0.02em] text-brand-text md:text-4xl" data-id="element-92" data-mp="1rdm0piyk3op7">Wat je meteen ontvangt</h2>
        <div className="grid auto-rows-fr grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-93" data-mp="25baiuj18ohqk">
          {items.map(item => <div key={item.text} className="flex min-h-[86px] items-center justify-center gap-3 rounded-2xl border border-brand-creamDark/70 bg-white px-5 py-5 shadow-[0_6px_18px_rgba(46,42,38,0.04)]" data-id="element-94" data-mp="azdp2jfbqzsc">
              <span className="text-2xl" data-id="element-95" data-mp="2n1x6tmxuo5w7">{item.emoji}</span>
              <span className="text-sm font-semibold text-brand-text sm:text-base" data-id="element-96" data-mp="2n3hzt84ingry">{item.text}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-semibold italic text-brand-green" data-id="element-97" data-mp="2wzbaelyod073">Alles bij de hand, voor elke les.</p>
      </div>
    </section>;
}